import { Injectable } from '@angular/core';
import { UtilsService } from './utils.service';

export interface Base64File {
  base64Content: string;
  name?: string;
  mimeType?: string;
  size?: number;
}

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(
    private utils: UtilsService
  ) { }


  async getDocumentFromBase64(
    base64Cont: string,
    mimeType?: string,
    name?: string
  ) {
    const blob = this.convertb64toBlob(base64Cont, mimeType);
    return {
      name: name ? name : '',
      mimeType: blob.type ? blob.type : '',
      base64Content: base64Cont,
      size: blob.size ? blob.size : 0
    };
  }


  async open(file: Base64File) {
    if (!file || !file.base64Content || !file.mimeType) {
      return;
    }
    const blob = this.convertb64toBlob(file.base64Content, file.mimeType);
    this.utils.createAnchorTag(blob, file.name);
  }

  convertb64toBlob(
    b64Data,
    contentType: string,
    sliceSize?: number
  ) {
    if (b64Data instanceof Blob) {
      return b64Data;
    }

    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
